import { render, staticRenderFns } from "./Weekly.vue?vue&type=template&id=efc7fff4&"
import script from "./Weekly.vue?vue&type=script&lang=js&"
export * from "./Weekly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports